import { useEffect, useState } from "react";

import detectRootInstalled from "~/pwa/detectRootInstalled";

const useRootInstalled = (): boolean => {
	const [rootInstalled, setRootInstalled] = useState(false);

	useEffect(() => {
		let active = true;
		detectRootInstalled().then((installed) => {
			if (active) setRootInstalled(installed);
		});
		return () => {
			active = false;
		};
	}, []);

	return rootInstalled;
};

export default useRootInstalled;
